module.exports = new __parcel__URL__("linear-logomark-darkmode.2e4a15d9.svg").toString();